import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';
import { useRef } from 'react';

import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { awsSeo } from './AwsCloudSolutionsPage.seo';
import type { AwsCloudSolutionsProps } from './AwsCloudSolutionsPage.types';
import { Benefits } from './Benefits';
import { CloudServices } from './CloudServices';
import { Faq } from './Faq';
import { Hero } from './Hero';
import { OurWork } from './OurWork';

export const AwsCloudSolutionsPage = ({
  blogPosts,
  caseStudies,
}: AwsCloudSolutionsProps) => {
  const offerRef = useRef<HTMLDivElement>(null);

  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...awsSeo} />
      <Hero />
      <CloudServices offerRef={offerRef} />
      <Benefits />
      <OurWork caseStudies={caseStudies} />
      <Faq />
      <Contact
        subtitle="We will answer any questions you may have related to AWS Cloud!"
        color="red"
      />
    </Layout>
  );
};
